var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool, color, expression, formatters, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, enumValues, resolveColor } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CancelIcon } from '../../../resources/assets/components/status/cancel.svg';
import { ReactComponent as CheckIcon } from '../../../resources/assets/components/status/check.svg';
import { ReactComponent as LocaleIcon } from '../../../resources/assets/components/status/locale.svg';
import { ReactComponent as MissedIcon } from '../../../resources/assets/components/status/missed.svg';
import { ReactComponent as TimeIcon } from '../../../resources/assets/components/status/time.svg';
import { ReactComponent as WarningIcon } from '../../../resources/assets/components/status/warning.svg';
import StampAPI from './stamp-api.js';
import { StampIcon } from './stamp-constants.js';
import './stamp.css';
let Stamp = class Stamp extends PureComponent {
    getIcon(name) {
        const icons = {
            [StampIcon.CANCELED_OUTLINE]: MissedIcon,
            [StampIcon.CANCELED]: CancelIcon,
            [StampIcon.CHECK]: CheckIcon,
            [StampIcon.CLOCK]: TimeIcon,
            [StampIcon.LOCALE]: LocaleIcon,
            [StampIcon.NONE]: null,
            [StampIcon.WARNING]: WarningIcon,
        };
        return name ? icons[name] : null;
    }
    getRootClasses() {
        const { className } = this.props;
        const rootClasses = {
            'c-stamp': true,
            [`${className}`]: Boolean(className),
        };
        return classNames(rootClasses);
    }
    getIconClasses() {
        const iconClasses = {
            'c-stamp__icon': true,
        };
        return classNames(iconClasses);
    }
    getLabelClasses() {
        const { enableAutoHide } = this.props;
        const labelClasses = {
            'c-stamp__label': true,
            'u-hide@xsm': Boolean(enableAutoHide),
            'u-truncate': true,
        };
        return classNames(labelClasses);
    }
    render() {
        const { color, formatters, icon } = this.props;
        const { label } = ModelService.formatProps(this.props, ['label'], formatters);
        const StampIcon = this.getIcon(icon);
        return (React.createElement("div", { className: this.getRootClasses() },
            StampIcon ?
                React.createElement("div", { className: this.getIconClasses(), style: resolveColor(color), "x-contrast": "cl" },
                    React.createElement(StampIcon, null)) : null,
            label ?
                React.createElement("span", { className: this.getLabelClasses() }, MessageService.translate(label)) : null));
    }
};
Stamp.propTypes = {
    className: string,
    color: color,
    enableAutoHide: bool,
    formatters: formatters,
    icon: oneOf(enumValues(StampIcon)),
    label: expression,
};
Stamp.defaultProps = {
    color: 'signal-gray-30',
};
Stamp = __decorate([
    AwesomeComponent({ api: StampAPI, type: ComponentType.DATA_DISPLAY })
], Stamp);
export { Stamp, };
export default Stamp;
//# sourceMappingURL=stamp.js.map